<template>
  <Surround
    :surround-image="surroundImage"
    :title="title"
    :back-link="backLink"
  >
    <div class="info-content">
      <div class="image-slider">
        <carousel
          ref="hoooper"
          :per-page="1"
          :navigation-enabled="true"
          :mouse-drag="false"
          :touch-drag="false"
          @mounted="fixupCompares"
        >
          <slide>
            <div class="compare-wrapper">
              <div class="compare">
                <image-compare
                  :before="M1"
                  :after="M2"
                >
                  <template v-slot:icon-left>
                    <img
                      class="handle-img"
                      src="@/assets/vl/handle-left.png"
                    >
                  </template>
                  <template v-slot:icon-right>
                    <img
                      class="handle-img"
                      src="@/assets/vl/handle-right.png"
                    >
                  </template>
                </image-compare>
              </div>
            </div>
          </slide>
          <slide>
            <div class="compare-wrapper">
              <div class="compare">
                <image-compare
                  :before="C1"
                  :after="C2"
                />
              </div>
            </div>
          </slide>
          <!-- <Navigation slot="hooper-addons" /> -->
        </carousel>
      </div>
      <div>
        <p>Roberto Burle Marx’s landscape designs resembled abstract paintings. Feeling inspired?</p>
        <router-link
          class="button"
          :to="{name: routeName}"
        >
          Create like Roberto Burle Marx
        </router-link>
      </div>
    </div>
  </Surround>
</template>

<script>
import Vue from 'vue'
import { Carousel, Slide } from 'vue-carousel'
import VueImageCompare from 'vue-image-compare'
Vue.use(VueImageCompare)

import M1 from '@/assets/vl/1AS.jpg'
import M2 from '@/assets/vl/1BS.jpg'
import C1 from '@/assets/vl/3A.jpg'
import C2 from '@/assets/vl/3B.jpg'

export default {
  name: 'InfoSlider',
  components: {
    Carousel,
    Slide
  },
  props: {
    routeName: {
      type: String,
      default: ''
    },
    surroundImage: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    backLink: {
      type: [String, Object, Boolean],
      default: false
    }
},
  data() {
    return {
      M1,
      M2,
      C1,
      C2
    }
  },
  methods: {
    fixupCompares() {
      // WHY??????
      setTimeout(()=> {
        window.dispatchEvent(new Event('resize'))
      }, 0)
    },
    hooperLoaded() {
      // Hooper has a WEIRD WEIRD issue with our styles on iOS.
      // Adding do-nothing touchstart handler on list items
      // does SOMETHING to help this. I wish I knew WHAT.
      const childs = this.$refs.hoooper.$refs.track.children
      for (let i = 0; i < childs.length; i++) {
        childs[i].addEventListener('touchstart', () => {}, {passive: true})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// Contains the slider in total
.info-content {
  width: 100%;
  @include flex-vertical;
  @include flex-fill-vertical;
  justify-content: space-around;
  padding: 2rem;
  overflow:hidden;
}
.image-slider {
  @include flex-vertical;
  @include flex-fill-vertical;
  justify-content: center;
}
.VueCarousel-slide {
  user-select: none;
  align-self: center;
}
/deep/ .image-compare-handle-icon.left {
  padding-right: 1px;
}
/deep/ .image-compare-handle-icon.right {
  padding-left: 1px;
}
.handle-img {
  width: 19px;
}
</style>
